module.exports = __webpack_public_path__ + "img/hardyDrillArms2.74aa910c.png";